import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Button, List } from 'antd'

@inject((store: any) => {
    const { popupStore, rightParamSetStore } = store
    return { popupStore, rightParamSetStore }
})
@observer
export default class RightParamSetPopup extends Component<any, any> {
    state: any = {
        errors: {},
        selectedItem: {},
        confirm: false
    }
    closePopup = () => {
        this.setState({ confirm: false, selectedItem: {} })
        this.props.rightParamSetStore.resetRightParamSets()
        this.props.popupStore.togglePopup(false)
    }
    toggleConfirmation = () => {
        this.setState(prevState => ({ confirm: !prevState.confirm }))
    }
    handleButtonClick = selectedItem => {
        const { rightParamSetSubmit } = this.props
        const { confirmation } = this.props.popupStore.info
        if (confirmation) {
            this.setState({ selectedItem, confirm: true })
        } else {
            rightParamSetSubmit(selectedItem)
        }
    }
    handleConfirm = async () => {
        const { rightParamSetSubmit } = this.props
        const { selectedItem } = this.state
        await rightParamSetSubmit(selectedItem)
        this.closePopup()
    }
    render() {
        const { rightParamSetStore, popupStore } = this.props
        const { selectedItem } = this.state
        const { title, buttonText, right_param_set_id, confirmation } = this.props.popupStore.info
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
            </div>
        )
        return (
            <Modal
                title={title ? title : 'רשימת טבלאות פרמטרים'}
                visible={popupStore.popupType === 'rightParamSets'}
                cancelText="ביטול"
                width={600}
                bodyStyle={{ padding: '0.5rem 1.5rem' }}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        flexDirection: 'column',
                        padding: '0.5rem 0rem 0.8rem'
                    }}
                >
                    <Input.Search
                        name="filterParameters"
                        placeholder="סינון על פי שם טבלה"
                        value={rightParamSetStore.filterText}
                        onChange={e => rightParamSetStore.filterList(e.target.value)}
                    />
                    {this.state.confirm && confirmation && (
                        <div
                            style={{
                                padding: '0.7rem',
                                backgroundColor: '#981616',
                                fontSize: '1rem',
                                color: 'white',
                                fontWeight: 'bold'
                            }}
                        >
                            <div>{confirmation}</div>
                            <div>
                                <a style={{ textDecoration: 'underline' }} onClick={() => this.toggleConfirmation()}>
                                    ביטול
                                </a>
                                |
                                <a style={{ textDecoration: 'underline' }} onClick={() => this.handleConfirm()}>
                                    אישור
                                </a>
                            </div>
                        </div>
                    )}
                    <List
                        className="center-table"
                        style={{ width: '100%' }}
                        rowKey="id"
                        dataSource={rightParamSetStore.filteredList}
                        pagination={{
                            hideOnSinglePage: true,
                            pageSize: 8
                        }}
                        renderItem={item => {
                            const selected = selectedItem['id'] && selectedItem['id'] === item['id']
                            return (
                                <List.Item
                                    style={{
                                        padding: '0.5rem 0.7rem',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        backgroundColor: selected ? '#fdefd0' : 'white'
                                    }}
                                >
                                    <div>
                                        {item['name']} (מזהה: {item['id']})
                                    </div>
                                    {buttonText && right_param_set_id !== item['id'] && !selected ? (
                                        <div>
                                            <Button
                                                style={{ marginLeft: '0' }}
                                                onClick={() => this.handleButtonClick(item)}
                                            >
                                                {buttonText}
                                            </Button>
                                        </div>
                                    ) : selected ? (
                                        'פוליסה לשיוך'
                                    ) : (
                                        'טבלה זו משוייכת לפוליסה'
                                    )}
                                </List.Item>
                            )
                        }}
                    />
                </div>
            </Modal>
        )
    }
}
